import React from "react";

const Footer: React.FC = () => {
  return (
    <section className="cta">
      <div className="container cta-inner">
        <h2>Stop second-guessing job descriptions.</h2>
        {/* <p>Paste a JD and get your fit score in seconds.</p> */}
      </div>
    </section>
  );
};

export default Footer;
